import { render, staticRenderFns } from "./FiltroPorColuna.vue?vue&type=template&id=5db0ef70&"
import script from "./FiltroPorColuna.vue?vue&type=script&lang=js&"
export * from "./FiltroPorColuna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports